import React, {useCallback, useEffect, useState} from "react";
import {Button, Form, FormGroup, Input, Label} from "reactstrap";

import Loading from "../components/Loading";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import {callRemote, GET, POST} from "../service/RemoteService";
import {determineIfTokenError} from "../store/AuthThunks";
import {useDispatch} from "react-redux";
import Select from "react-select";
import {displayAlert} from "../store/AlertSlice";

export const ManualPayment = () => {
    let dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();
    const [photographers, setPhotographers] = useState();
    const [payment, setPayment] = useState({
        amount: 0,
        description: '',
        explanation: '',
        photographer: null,
    });
    const [validation, setValidation] = useState({
        amount: true,
        description: true,
        explanation: true,
        photographer: true
    });

    const getPhotographers = useCallback(() => {
        callRemote(getAccessTokenSilently, GET, "/photographers/")
            .then(resp => {
                setPhotographers(resp.map(
                    p => { return { value: p.id, label: p.name, data: p } })
                );
            }).catch(e => {
            dispatch(determineIfTokenError(e));
        });
    }, [dispatch, setPhotographers, getAccessTokenSilently]);

    useEffect(() => {
        getPhotographers();
    }, [getPhotographers]);

    const submit = async (e) => {
        e.preventDefault();
        if(!validate()) {
            return;
        }
        try {
            await callRemote(getAccessTokenSilently, POST, "/stripe/manual-payment", payment);
        } catch (e) {
            dispatch(determineIfTokenError(e));
            return;
        }

        setPayment({
            amount: 0,
            description: '',
            explanation: '',
            photographer: null
        });
        dispatch(displayAlert(true, "Payment Sent!"));
    };

    const handleInputChange = e => {
        setPayment({ ...payment, [e.target.name]: e.target.value });
        setValidation({ ...validation, [e.target.name]: e.target.value !== '' });
    };
    const handlePhotographerChange = e => {
        setPayment({ ...payment, photographer: e.value });
    };

    const validate = () => {
        const newValidation = {
            amount: payment.amount > 0 && payment.amount <= 200,
            description: payment.description !== '',
            explanation: payment.explanation !== '',
            photographer: payment.photographer !== null && payment.photographer !== undefined
        };
        setValidation(
            newValidation
        )
        return Object.values(newValidation).every(Boolean);
    }

    return (
        <div>
            <Form onSubmit={submit}>
                <FormGroup>
                    <Label>Photographer</Label>
                    <Select name="photographer" options={photographers} isSearchable={true} onChange={handlePhotographerChange} aria-invalid={!validation.photographer}/>
                </FormGroup>
                <FormGroup>
                    <Label>Amount</Label>
                    <Input type="number" name="amount" value={payment.amount} onChange={handleInputChange} invalid={!validation.amount} min="1" max="200" step="1"/>
                </FormGroup>
                <FormGroup>
                    <Label>Stripe Description (Ex: Lot Number: 250635742 VIN: WVWWA7AU8KW195492)</Label>
                    <Input type="text" name="description" value={payment.description} onChange={handleInputChange} invalid={!validation.description}/>
                </FormGroup>
                <FormGroup>
                    <Label>Explanation</Label>
                    <Input type="text" name="explanation" value={payment.explanation} onChange={handleInputChange} invalid={!validation.explanation} />
                </FormGroup>

                <Button color="danger">Send Payment</Button>
            </Form>
        </div>
    );
};

export default withAuthenticationRequired(ManualPayment, {
    onRedirecting: () => <Loading />,
});
